<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-toolbar
    id="core-toolbar"

    flat
    prominent
    style="background: #eee;"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title
        class="tertiary--text font-weight-light"
      >
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ 'krita.home' | translate }}/ {{ title | translate }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2>
        <!--<v-text-field-->
        <!--v-if="responsiveInput"-->
        <!--class="mr-4 mt-2 krita-dark-input"-->
        <!--label="Search..."-->
        <!--hide-details-->
        <!--color="krita-dark" />-->
        <!--<v-menu-->
        <!--bottom-->
        <!--left-->
        <!--content-class="dropdown-menu"-->
        <!--offset-y-->
        <!--transition="slide-y-transition">-->
        <!--<router-link-->
        <!--v-ripple-->
        <!--slot="activator"-->
        <!--class="toolbar-items"-->
        <!--to="">-->
        <!--<v-badge-->
        <!--color="error"-->
        <!--overlap>-->
        <!--<template slot="badge">-->
        <!--{{ notifications.length }}-->
        <!--</template>-->
        <!--<v-icon color="tertiary">mdi-bell</v-icon>-->
        <!--</v-badge>-->
        <!--</router-link>-->
        <!--<v-card>-->
        <!--<v-list dense>-->
        <!--<v-list-tile-->
        <!--v-for="notification in notifications"-->
        <!--:key="notification"-->
        <!--@click="onClick">-->
        <!--<v-list-tile-title v-text="notification" />-->
        <!--</v-list-tile>-->
        <!--</v-list>-->
        <!--</v-card>-->
        <!--</v-menu>-->
        <v-btn
          v-if="UserInfo.IsAdmin"
          icon>
          <v-icon @click="reloadTranslations">refresh</v-icon>
        </v-btn>
        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition">
          <router-link
            v-ripple
            slot="activator"
            class="toolbar-items"
            to="">
            <v-icon color="tertiary">mdi-web</v-icon>
            {{ 'krita.language' | translate }}
          </router-link>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="language in getLanguages()"
                :key="language.code"
                @click="onClick(language.code)">
                <img
                  :src="language.url"
                  :alt="language.alt"
                  height="20px"
                  style="margin-right: 10px"
                >{{ language.alt }}
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
        <v-autocomplete 
          v-model="companySelection"
          :items="claimants"
          :placeholder="selectedClaimant.ClaimantName"
          item-text="claimant"
          item-value="id"
          class="input"
          @change="selectCompany(claimants.id)"
          @focusout="fillCompanySelectOnLoad"
        >
          <template v-slot:selection="data">
            <v-flex xs12>
              <v-layout
                justify-center
                align-content-center>
                <span>{{ data.item.claimant }}</span>
              </v-layout>
            </v-flex>
          </template>
        </v-autocomplete>
<!--        <v-menu-->
<!--          bottom-->
<!--          left-->
<!--          content-class="dropdown-menu"-->
<!--          offset-y-->
<!--          transition="slide-y-transition">-->
<!--          <router-link-->
<!--            v-ripple-->
<!--            slot="activator"-->
<!--            class="toolbar-items"-->
<!--            to="">-->
<!--            {{ selectedClaimant.ClaimantId }} - {{ selectedClaimant.ClaimantName }}<v-icon class="space">expand_more</v-icon>-->
<!--          </router-link>-->
<!--          <v-card style="max-height: 200px">-->
<!--            <v-list dense>-->
<!--              <v-list-tile-->
<!--                v-for="company in UserInfo.AccessToCompanies"-->
<!--                :key="company.ClaimantId"-->
<!--                @click="selectCompany(company.ClaimantId)">-->
<!--                <v-list-tile-title>-->
<!--                  {{ company.ClaimantId }} - {{ company.ClaimantName }}-->
<!--                </v-list-tile-title>-->
<!--              </v-list-tile>-->
<!--            </v-list>-->
<!--          </v-card>-->
<!--        </v-menu>-->
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>

import { mapMutations} from 'vuex';
import {mapState} from 'vuex';

export default {
  data: () => ({
	companies: [],
    title: null,
    responsive: false,
    responsiveInput: false,
    companySelection: {}
  }),
  computed: {
    ...mapState({
      UserInfo: state => state.userInfo,
      selectedClaimant: state => state.userInfo.SelectedClaimant
    }),
    claimants ()
    {
        let claimants = [];
        for (let claimant of this.UserInfo.AccessToCompanies)
        {
            let claimantClient = {};
            claimantClient =
                    { claimant: claimant.ClaimantName + ' (kt. ' + claimant.ClaimantRegistryId.slice(0,6) + '-' + claimant.ClaimantRegistryId.slice(6) + ')',
                      id: claimant.ClaimantId
                    };
            claimants.push(claimantClient);
        }
        return claimants;
    },
  },

  watch: {
    '$route' (val) {
      this.title = 'krita.' + val.name.replace(/\s+/g, '').toLowerCase() + '.header.home'
    }
  },

  mounted ()
  {
    let self = this;
    self.onResponsiveInverted();
    window.addEventListener('resize', self.onResponsiveInverted);
    self.fillCompanies();
    self.fillCompanySelectOnLoad ();

  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    getLanguages()
    {
      let self = this;
      return [
        { url: require('../../assets/en.svg'), alt: self.$t('krita.language.english'), code: 'en' },
        { url: require('../../assets/is.svg'), alt: self.$t('krita.language.icelandic'), code: 'is' },
      ];
    },
    fillCompanySelectOnLoad ()
    {
      let self = this;

      self.companySelection = { claimant: self.selectedClaimant.ClaimantName + ' (kt. ' + self.selectedClaimant.Kennitala.slice(0,6) + '-' + self.selectedClaimant.Kennitala.slice(6) + ')',
        id: self.selectedClaimant.ClaimantId
      };
    },
    reloadTranslations ()
    {
      let self = this;

      self.$store.dispatch('translations/getTranslationsDictionary').then(response =>
        {
          let translations = response;
          self.$i18n.replace(self.$i18n.locale(),translations)
        }
      )
    },
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick (code) {
      let self = this;
      self.$store.commit('setLang', code);
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    selectCompany ()
    {
      let self = this;

      if(self.companySelection === undefined)
      {
        return;
      }
      self.$store.dispatch('user/selectCompany', self.companySelection).then(response =>
      {
        self.$store.commit('setCompany', response);
      });
    },
    fillCompanies (){
      let self = this;
      if (self.UserInfo === null)
      {
        return;
      }
      for (let company of self.UserInfo.AccessToCompanies)
      {
        this.companies.push(company.ClaimantId + " - " + company.ClaimantName);
      }
    }
  }
}
</script>

<style scoped lang = "scss">
  #core-toolbar a {
    text-decoration: none;
  }
  .space {
    margin-left: 10px;
  }
  .input{
    padding-top: 17.5px !important;
  }
</style>
